import { render, staticRenderFns } from "./DomainsCrud.vue?vue&type=template&id=5b516ea2&scoped=true"
import script from "./DomainsCrud.vue?vue&type=script&lang=js"
export * from "./DomainsCrud.vue?vue&type=script&lang=js"
import style0 from "./DomainsCrud.vue?vue&type=style&index=0&id=5b516ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b516ea2",
  null
  
)

export default component.exports